module.exports = __webpack_public_path__ + "static/media/home-security.5b248443.jpg";